import { UseFormReturn, useWatch } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CURRENCIES } from "@/helpers/currency-map";
import { PaymentPageWizardData } from "./wizard-form";

export default function StepPricing({
  form,
}: {
  form: UseFormReturn<PaymentPageWizardData>;
}) {
  const authEnabled = useWatch({
    control: form.control,
    name: "is_auth_enabled",
  });

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="currency"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Currency</FormLabel>
              <Select value={field.value} onValueChange={field.onChange}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Currency">
                      {field.value}
                    </SelectValue>
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {CURRENCIES.map((c) => (
                    <SelectItem key={c.value} value={c.value}>
                      {c.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="fallback_amount"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Fallback Amount</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  placeholder="Used only if the live bundle lookup fails"
                  value={field.value ?? ""}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value ? Number(e.target.value) : null,
                    )
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="redirect_link"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Redirect Link</FormLabel>
              <FormControl>
                <Input
                  placeholder="https://…"
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={form.control}
        name="is_auth_enabled"
        render={({ field }) => (
          <FormItem className="flex items-center justify-between border rounded-md p-3">
            <FormLabel>Require Auth</FormLabel>
            <FormControl>
              <Switch
                checked={field.value}
                onCheckedChange={(checked) => {
                  field.onChange(checked);
                  // Login redirect only matters when auth is required.
                  if (!checked) form.setValue("login_redirect_url", null);
                }}
              />
            </FormControl>
          </FormItem>
        )}
      />

      {authEnabled && (
        <FormField
          control={form.control}
          name="login_redirect_url"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Login Redirect URL</FormLabel>
              <FormControl>
                <Input
                  placeholder="https://…"
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}
